import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(<circle cx="12" cy="12" r="2" />, 'Ellipse')
